(function () {
  'use strict';
  const root = document.getElementById('je-birthflower-product');
  if (!root || root.dataset.mobileEditorInitialized) return;
  const $ = id => root.querySelector('#' + id);
  const dialog = $('mobile-editor'), opener = $('open-mobile-editor');
  if (!dialog || !opener || typeof dialog.showModal !== 'function' || typeof globalThis.JEPersonalizationViewport?.create !== 'function') return;
  const openers = [opener, $('open-mobile-editor-inline')].filter(Boolean);
  const preview = $('mobile-editor-preview'), bottle = $('mobile-editor-bottle');
  const design = $('mobile-editor-design'), footer = $('mobile-editor-footer');
  const selector = $('mobile-bottle-select'), bottleField = $('mobile-bottle-field');
  const proofs = $('proofs'), title = $('mobile-editor-title'), closeButton = $('close-mobile-editor');
  const tabs = Array.from(dialog.querySelectorAll('[data-mobile-panel]'));
  const gallery = root.querySelector('.product-gallery'), options = root.querySelector('.bottle-options');
  const personalization = root.querySelector('.personalize-panel'), purchase = root.querySelector('.purchase-row');
  const settings = root.querySelector('.set-controls'), workspace = root.querySelector('.proof-workspace');
  const addName = $('add-name'), detailButton = $('mobile-preview-detail'), cup = $('cup-preview');
  const toolHeading = $('mobile-tool-heading'), toolTitle = $('mobile-tool-title'), toolBack = $('mobile-tool-back');
  const flowerPicker = $('mobile-flower-picker'), monthFlowers = $('mobile-month-flowers'), otherFlowers = $('mobile-other-flowers');
  if (![preview, bottle, design, footer, selector, bottleField, proofs, title, closeButton,
    gallery, options, personalization, purchase, settings, workspace, addName, detailButton, cup,
    toolHeading, toolTitle, toolBack, flowerPicker, monthFlowers, otherFlowers].every(Boolean)) return;
  root.dataset.mobileEditorInitialized = 'true';

  const mobile = window.matchMedia('(max-width: 760px)');
  const overflowProperties = ['overflow', 'overflow-x', 'overflow-y'];
  let mounted = false, placements = [], previousIds = [], activeId = '';
  let returnFocus = null, pagePosition = null, bodyOverflow = [];
  let addContent = [];
  let activeTool = null, flowers = [], pickerBuilt = false;
  const viewport = JEPersonalizationViewport.create({ dialog, isOpen: () => mounted, title, doneButton: $('mobile-done-typing') });
  try { flowers = JSON.parse($('je-birthflower-catalog')?.textContent || '{}').flowers || []; } catch { /* The native flower select remains available. */ }
  flowers = Array.isArray(flowers) ? flowers.filter(flower => flower && typeof flower.id === 'string' && typeof flower.label === 'string' && typeof flower.url === 'string') : [];

  function cards() { return Array.from(proofs.querySelectorAll('.proof')); }
  function controlsScroller() { return dialog.querySelector('.mobile-editor-panels'); }
  function closeTool(returnToTrigger = true) {
    if (!activeTool) return;
    const previous = activeTool;
    activeTool = null;
    delete dialog.dataset.tool;
    toolHeading.hidden = true; flowerPicker.hidden = true;
    design.hidden = dialog.dataset.panel === 'bottle';
    if (previous.details) previous.details.open = false;
    if (previous.trigger?.matches('button')) previous.trigger.setAttribute('aria-expanded', 'false');
    const scroller = controlsScroller();
    if (scroller) scroller.scrollTop = returnToTrigger ? previous.scrollTop : 0;
    if (returnToTrigger && previous.trigger?.isConnected) previous.trigger.focus({ preventScroll: true });
  }
  function openTool(kind, card, trigger, details = null) {
    if (!mounted || card?.dataset.active !== 'true') return;
    closeTool(false);
    setPanel('design');
    activeTool = { kind, rowId: card.dataset.rowId, trigger, details, scrollTop: controlsScroller()?.scrollTop || 0 };
    dialog.dataset.tool = kind;
    toolTitle.textContent = toolTitle.dataset[kind];
    toolHeading.hidden = false;
    flowerPicker.hidden = kind !== 'flowers';
    design.hidden = kind === 'flowers';
    if (trigger?.matches('button')) trigger.setAttribute('aria-expanded', 'true');
    if (controlsScroller()) controlsScroller().scrollTop = 0;
    toolBack.focus({ preventScroll: true });
  }
  function syncFlowers() {
    if (!mounted || !flowers.length) return;
    cards().forEach(card => {
      const field = card.querySelector('.flower-field'), select = field?.querySelector('select');
      if (!select) return;
      let button = field.querySelector('.mobile-browse-flowers');
      if (!button) {
        button = document.createElement('button'); button.type = 'button'; button.className = 'mobile-browse-flowers';
        button.setAttribute('aria-label', flowerPicker.dataset.browseLabel);
        button.setAttribute('aria-controls', flowerPicker.id); button.setAttribute('aria-expanded', 'false');
        const image = document.createElement('img'); image.alt = ''; image.width = 44; image.height = 44;
        const text = document.createElement('span'); text.textContent = flowerPicker.dataset.browseText;
        button.append(image, text); field.prepend(button);
        button.addEventListener('click', () => {
          if (select.disabled) return;
          buildFlowerPicker(select);
          openTool('flowers', card, button);
        });
      }
      const image = button.querySelector('img'), flower = flowers.find(item => item.id === select.value);
      button.disabled = select.disabled;
      if (flower && image.getAttribute('src') !== flower.url) image.src = flower.url;
    });
  }
  function buildFlowerPicker(select) {
    if (!pickerBuilt) {
      flowers.forEach(flower => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.flowerId = flower.id;
        button.setAttribute('aria-label', flower.label);
        const image = document.createElement('img'); image.alt = ''; image.width = 72; image.height = 66;
        image.loading = 'lazy'; image.decoding = 'async'; image.src = flower.thumbnailUrl || flower.url;
        image.addEventListener('error', () => { image.style.visibility = 'hidden'; });
        const label = document.createElement('span'); label.textContent = flower.label;
        button.append(image, label);
        (flower.month ? monthFlowers : otherFlowers).append(button);
      });
      pickerBuilt = true;
    }
    flowerPicker.querySelectorAll('button[data-flower-id]').forEach(button => {
      const option = Array.from(select.options).find(item => item.value === button.dataset.flowerId);
      button.hidden = !option;
      button.disabled = select.disabled || !option || option.disabled;
      button.setAttribute('aria-pressed', String(button.dataset.flowerId === select.value));
    });
  }
  function syncSelector() {
    const rows = cards(), ids = new Set(rows.map(card => card.dataset.rowId));
    Array.from(selector.options).forEach(option => { if (!ids.has(option.value)) option.remove(); });
    rows.forEach((card, index) => {
      const id = card.dataset.rowId;
      let option = Array.from(selector.options).find(item => item.value === id);
      if (!option) { option = document.createElement('option'); option.value = id; selector.append(option); }
      const name = card.querySelector('.name-field input')?.value.trim();
      option.textContent = name ? (index + 1) + '. ' + name : 'Name ' + (index + 1);
      if (selector.options[index] !== option) selector.insertBefore(option, selector.options[index] || null);
    });
    if (!rows.length) {
      const empty = document.createElement('option');
      empty.value = ''; empty.textContent = bottleField.dataset.emptyLabel;
      selector.append(empty);
    }
    const active = rows.find(card => card.dataset.active === 'true') || rows[0];
    activeId = active?.dataset.rowId || '';
    selector.value = activeId;
    selector.disabled = rows.length < 2;
    bottleField.hidden = !mounted;
    if (activeTool && (activeTool.rowId !== activeId || !activeTool.trigger?.isConnected)) closeTool(false);
    syncFlowers();
  }
  function selectRow(id) {
    if (!cards().some(card => card.dataset.rowId === id)) return;
    if (id !== activeId) {
      closeTool(false);
      const scroller = dialog.querySelector('.mobile-editor-panels');
      if (scroller) scroller.scrollTop = 0;
    }
    root.dispatchEvent(new CustomEvent('bloom:select-row', { detail: { id } }));
    syncSelector();
  }
  function syncDetail() {
    const available = mounted && cup.dataset.detailAvailable === 'true';
    detailButton.hidden = !available;
    const enabled = available && cup.dataset.previewDetail === 'true';
    detailButton.textContent = enabled ? detailButton.dataset.fullBottle : detailButton.dataset.closeUp;
    detailButton.dataset.active = String(enabled);
  }
  function setPanel(panel, focus = false) {
    closeTool(false);
    const selected = panel === 'bottle' ? 'bottle' : 'design';
    const scroller = dialog.querySelector('.mobile-editor-panels');
    if (scroller && dialog.dataset.panel !== selected) scroller.scrollTop = 0;
    dialog.dataset.panel = selected;
    bottle.hidden = selected !== 'bottle';
    design.hidden = selected !== 'design';
    tabs.forEach(tab => {
      const current = tab.dataset.mobilePanel === selected;
      tab.setAttribute('aria-selected', String(current));
      tab.tabIndex = current ? 0 : -1;
      if (current && focus) tab.focus({ preventScroll: true });
    });
  }
  function move(element, destination, before = null) {
    const marker = document.createComment('birthflower mobile position');
    element.before(marker);
    placements.push({ element, marker });
    destination.insertBefore(element, before);
  }
  function restore() {
    if (!mounted) return;
    closeTool(false);
    mounted = false;
    delete root.dataset.mobileEditor;
    root.dispatchEvent(new CustomEvent('bloom:preview-detail', { detail: { enabled: false } }));
    addName.replaceChildren(...addContent);
    addContent = [];
    // Restore nested settings before restoring their containing panel.
    placements.reverse().forEach(({ element, marker }) => marker.replaceWith(element));
    placements = [];
    bottleField.hidden = true;
    syncDetail();
    overflowProperties.forEach(property => document.body.style.removeProperty(property));
    bodyOverflow.forEach(({ property, value, priority }) => {
      if (value) document.body.style.setProperty(property, value, priority);
    });
    bodyOverflow = [];
    viewport.close();
    openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    // A review may still be open when the device rotates to desktop width.
    if (!$('review-dialog')?.open && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    if (pagePosition) window.scrollTo({ left: pagePosition.x, top: pagePosition.y, behavior: 'instant' });
    returnFocus = null;
    pagePosition = null;
  }
  function closeEditor() {
    if (dialog.open) dialog.close();
    restore();
  }
  function openEditor(event) {
    if (!mobile.matches || mounted) return;
    // Touch browsers do not always focus a tapped button before firing click.
    returnFocus = openers.includes(event?.currentTarget) ? event.currentTarget : document.activeElement;
    pagePosition = { x: window.scrollX, y: window.scrollY };
    bodyOverflow = overflowProperties.map(property => ({ property,
      value: document.body.style.getPropertyValue(property), priority: document.body.style.getPropertyPriority(property) }));
    mounted = true;
    move(gallery, preview);
    move(options, bottle);
    move(personalization, design);
    const purchaseSummary = root.querySelector('[data-purchase-summary="product"]');
    if (purchaseSummary) move(purchaseSummary, design);
    move(purchase, footer);
    const handoff = root.querySelector('.studio-handoff');
    if (handoff) move(handoff, footer);
    move(settings, personalization);
    move(addName, bottleField);
    addContent = Array.from(addName.childNodes);
    addName.textContent = bottleField.dataset.addLabel;
    root.dataset.mobileEditor = 'true';
    document.body.style.setProperty('overflow', 'hidden');
    previousIds = cards().map(card => card.dataset.rowId);
    syncSelector();
    if (activeId) selectRow(activeId);
    setPanel('design');
    // An explicit add-name action always starts at the name, even when the
    // shopper previously left a size adjustment open on desktop.
    cards().forEach(card => card.querySelectorAll('.proportion-controls[open]').forEach(details => { details.open = false; }));
    if (controlsScroller()) controlsScroller().scrollTop = 0;
    viewport.open();
    try {
      dialog.showModal();
      openers.forEach(button => button.setAttribute('aria-expanded', 'true'));
      const input = cards().find(card => card.dataset.active === 'true')?.querySelector('.name-field input');
      const canEnterName = input && !input.disabled && !input.readOnly && workspace.getAttribute('aria-busy') !== 'true' && $('error')?.hidden !== false;
      // Focus synchronously from the shopper's tap. Loading and retry events
      // must never summon the keyboard later or take focus from another field.
      (canEnterName ? input : title).focus({ preventScroll: true });
    } catch {
      restore();
      // If native dialogs fail, expose the original inline editing and review flow.
      delete root.dataset.mobileReady;
      opener.closest('.mobile-editor-launch').hidden = true;
      openers.forEach(button => { button.hidden = true; });
      const fallback = cards().find(card => card.dataset.active === 'true')?.querySelector('.name-field input') || addName;
      fallback.focus();
    }
  }

  openers.forEach(button => button.addEventListener('click', openEditor));
  closeButton.addEventListener('click', closeEditor);
  dialog.addEventListener('cancel', event => { event.preventDefault(); if (activeTool) closeTool(); else closeEditor(); });
  dialog.addEventListener('close', restore);
  $('review-dialog')?.addEventListener('close', () => queueMicrotask(() => {
    // Rotation can restore the page while review stays open. Return to its visible action.
    if (!mounted && mobile.matches && root.dataset.mobileReady === 'true' && !$('review-design')?.disabled) {
      opener.focus({ preventScroll: true });
    }
  }));
  toolBack.addEventListener('click', () => closeTool());
  flowerPicker.addEventListener('click', event => {
    const button = event.target.closest('button[data-flower-id]');
    if (!button || button.disabled || activeTool?.kind !== 'flowers') return;
    const card = cards().find(item => item.dataset.rowId === activeTool.rowId && item.dataset.active === 'true');
    const select = card?.querySelector('.flower-input select');
    if (!select || select.disabled || !Array.from(select.options).some(option => option.value === button.dataset.flowerId && !option.disabled)) return;
    select.value = button.dataset.flowerId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closeTool();
  });
  proofs.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches('.proportion-controls') || !mounted) return;
    if (details.open && activeTool?.details !== details) openTool('adjustments', details.closest('.proof'), details.querySelector('summary'), details);
    else if (!details.open && activeTool?.details === details) closeTool();
  }, true);
  proofs.addEventListener('keydown', event => {
    if (mounted && event.key === 'Enter' && !event.isComposing && event.keyCode !== 229 && event.target.matches('.name-field input')) {
      event.preventDefault(); viewport.finishTyping();
    }
  });
  selector.addEventListener('change', () => selectRow(selector.value));
  detailButton.addEventListener('click', () => {
    root.dispatchEvent(new CustomEvent('bloom:preview-detail', { detail: { enabled: cup.dataset.previewDetail !== 'true' } }));
    syncDetail();
  });
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => setPanel(tab.dataset.mobilePanel));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      setPanel(tabs[next].dataset.mobilePanel, true);
    });
  });
  document.addEventListener('bloom:change', () => {
    const ids = cards().map(card => card.dataset.rowId);
    if (mounted) {
      const added = ids.filter(id => !previousIds.includes(id));
      const removedIndex = previousIds.indexOf(activeId);
      if (added.length) { setPanel('design'); selectRow(added[added.length - 1]); }
      else if (activeId && !ids.includes(activeId) && ids.length) {
        selectRow(ids[Math.min(Math.max(removedIndex, 0), ids.length - 1)]);
      }
    }
    previousIds = ids;
    syncSelector();
  });
  root.addEventListener('bloom:invalid-name', () => { if (mounted) setPanel('design'); });
  root.addEventListener('focusin', syncSelector);
  // Product-side active changes do not necessarily emit a design change.
  new MutationObserver(syncSelector).observe(proofs, { subtree: true, attributes: true, attributeFilter: ['data-active'] });
  new MutationObserver(syncDetail).observe(cup, { attributes: true, attributeFilter: ['data-detail-available', 'data-preview-detail'] });
  mobile.addEventListener('change', () => { if (!mobile.matches) closeEditor(); });
  syncSelector();
  previousIds = cards().map(card => card.dataset.rowId);
  root.dataset.mobileReady = 'true';
  opener.closest('.mobile-editor-launch').hidden = false;
})();
